module.exports = __webpack_public_path__ + "media/containers/common/Images/icBot-cc33bbde66f3367c5ba2b4552b838a96.png";